// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PLNi","label":"styles_label__PioFg"};